export default __webpack_public_path__ + "static/hotel-widget-e58bca630cb7353309319a781902be85.webp";